export default __webpack_public_path__ + "static/media/celebration.55e390f2.svg";